import React from "react"
import PropTypes from "prop-types"

import MagnifyGlassIcon from "~/public/static/images/svg/magnifyingGlassIcon.svg"
import Dropdown from "~/components/Form/Dropdown"
import { STATES } from "~/utilities/constants"

const StatesDropdown = ({ selectedState, autoFocus, onChange, noIcon, buildOptions }) => {
  return (
    <Dropdown
      autoFocus={autoFocus}
      blurInputOnSelect
      maxMenuHeight={140}
      imgSrc={noIcon ? null : MagnifyGlassIcon}
      value={{
        value: selectedState,
        label: STATES[selectedState]
      }}
      onChange={onChange}
      options={buildOptions()}
      noLabel
      bold={false}
    />
  )
}

StatesDropdown.defaultProps = {
  autoFocus: true,
  buildOptions: () => {
    const FIRST_STATE_KEYS = ["NY", "NJ", "CT", "CA"]
    const STATE_KEYS = Object.keys(STATES)
    const firstStates = []
    const restOfStates = []
    // format object for dropdown
    const buildOption = shortName => ({
      value: shortName,
      label: STATES[shortName]
    })
    // build first states to show
    FIRST_STATE_KEYS.forEach(shortName => {
      firstStates.push(buildOption(shortName))
    })
    // build the rest of the states
    STATE_KEYS.forEach(shortName => {
      const option = buildOption(shortName)
      if(!FIRST_STATE_KEYS.includes(shortName)) {
        restOfStates.push(option)
      }
    })
    return [
      ...firstStates,
      ...restOfStates
    ]
  }
}

StatesDropdown.propTypes = {
  selectedState: PropTypes.oneOf(Object.keys(STATES)).isRequired,
  autoFocus: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  buildOptions: PropTypes.func
}

export default StatesDropdown
